/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import moment from 'moment';

import { Container, Grid, Menu as BaseMenu, Header } from 'semantic-ui-react';
import { Divider, PageHeader } from '../../../components';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import InvoicesList from '../containers/InvoicesList';

import withModal from '../../../lib/withModal';
import type { ModalDialogTrigger } from '../../../type';
import SalonSubscriptionDialog from '../../../layouts/salon/containers/SalonSubscriptionDialog';

const Menu = styled(BaseMenu)`
    &.menu {
        margin: -0.5em -1em !important;
    }
`;

const WarningButton = styled(Button)`
    &.danger {
        background-color: #db2828 !important;
        color: #fff !important;
    }
`;


const SubscriptionButton = withModal(
    ({ open, onOpen, onClose, salon }: ModalDialogTrigger) => (
        <SalonSubscriptionDialog
            salon={salon}
            trigger={
                <Button onClick={onOpen}>
                    <FormattedMessage
                        id="pages.administrator.InvoicesPage.change"
                        defaultMessage="Change payment method"
                    />
                </Button>
            }
            open={open}
            onClose={onClose}
        />
    ),
);


const InvoicesPage = ({ intl, salon, subscription, onCancel, cancelling }) => (
    <Container fluid>
        <Menu secondary>
            <BaseMenu.Item header>
                <PageHeader>
                    <FormattedMessage
                        id="pages.administrator.InvoicesPage.title"
                        defaultMessage="My plan"
                    />
                    {subscription && subscription.status === "active" &&
                        <div>
                            <Header.Subheader>
                                <FormattedMessage
                                    id="pages.administrator.InvoicesPage.startDate"
                                    defaultMessage="Start date"
                                />: {moment(subscription.currentPeriodStart * 1000).format('DD.MM.YYYY')}
                            </Header.Subheader>
                            {!!subscription.canceledAt &&
                                <Header.Subheader>
                                    <FormattedMessage
                                        id="pages.administrator.InvoicesPage.endDate"
                                        defaultMessage="End Date"
                                    />: {moment(subscription.currentPeriodEnd * 1000).format('DD.MM.YYYY')}
                                </Header.Subheader>
                            }
                            <Header.Subheader>
                                <FormattedMessage
                                    id="pages.administrator.InvoicesPage.price"
                                    defaultMessage="Price"
                                />: {(subscription.amount / 100).toFixed(2)} {subscription.currency.toUpperCase()}
                                <FormattedMessage
                                    id="pages.administrator.InvoicesPage.monthly"
                                    defaultMessage="/month"
                                />
                            </Header.Subheader>
                            <SubscriptionButton salon={salon} />
                            {!subscription.canceledAt &&
                                <WarningButton disabled={cancelling} loading={cancelling} className="danger" onClick={onCancel}>
                                    <FormattedMessage
                                        id="pages.administrator.InvoicesPage.cancel"
                                        defaultMessage="Cancel my subscription"
                                    />
                                </WarningButton>}
                        </div>
                    }
                </PageHeader>
            </BaseMenu.Item>
        </Menu>
        <Divider />
        <Grid columns={1}>
            <Grid.Column>
                <InvoicesList />
            </Grid.Column>
        </Grid>
    </Container>
);

export default injectIntl(InvoicesPage);
